/**
 * Module-level accessor for the active WsActions instance.
 *
 * On the owner webview this holds an `OwnerWsActions` (wraps the real
 * DenkerWebSocket).  On mirror webviews it holds a `MirrorWsActions`
 * (marshals actions via Tauri events to the owner).
 *
 * Both implement the same `WsActions` interface so callers don't need
 * to know which webview role they're running on.
 *
 * Do NOT use this for reactive rendering — it is not observable. Read
 * it inside event callbacks when firing a one-off WS action.
 */

import type { WsActions } from "@/api/ws-actions";

let currentWs: WsActions | null = null;

export function setCurrentDenkerWs(ws: WsActions | null): void {
  currentWs = ws;
}

export function getCurrentDenkerWs(): WsActions | null {
  return currentWs;
}
